import React from 'react';

const ActiveJobCard = ({ data, onClick }) => {
  const { status = 'Active', title = 'Title', description = 'Description', id } = data || {};

  const statusColors = {
    Active: 'bg-blue-100 text-blue-900',
    Pending: 'bg-yellow-100 text-yellow-900',
    Closed: 'bg-gray-100 text-gray-700',
    Urgent: 'bg-red-100 text-red-900',
  };

  return (
    <div className="h-full bg-white p-5 flex flex-col justify-between rounded-lg shadow-sm hover:shadow-md transition-shadow">
      <div>
        <span className={`${statusColors[status] || statusColors.Active} px-3 py-1 rounded-lg text-sm font-medium`}>
          {status}
        </span>
        <h3 className="mt-3 text-lg font-semibold text-gray-900">{title}</h3>
        <p className="text-sm text-gray-500 mt-2 line-clamp-2">
          {description}
        </p>
      </div>
      <button
        onClick={() => onClick && onClick({ type: 'activeJob', data })}
        className="text-secondary-600 hover:text-secondary-800 text-sm font-medium mt-4 text-left hover:underline"
      >
        More →
      </button>
    </div>
  );
};

export default ActiveJobCard;
